import type { Address } from '../../model/types';

export function compareAddresses(
  addressA: Address,
  addressB: Address
): boolean {
  return (
    addressA.country === addressB.country &&
    addressA.region === addressB.region &&
    addressA.province === addressB.province &&
    addressA.cityOrMunicipality === addressB.cityOrMunicipality &&
    addressA.postalCode === addressB.postalCode &&
    addressA.barangay === addressB.barangay &&
    addressA.streetAndHouse === addressB.streetAndHouse &&
    (addressA.unitAndFloor ?? '') === (addressB.unitAndFloor ?? '')
  );
}
